/**
 * Sidebar icons mapping for the targeted support application.
 * Maps sidebar icon types to their corresponding Lucide icon components.
 */
import { GlobeIcon } from "@targeted-support/ui/components/icons";
import {
  Clock,
  FileText,
  FlaskConical,
  Info,
  Layers3,
  Lightbulb,
  ListChecks,
  MessageSquare,
  NotebookPen,
  ScrollText,
  Shield,
  Target,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";
import type { SidebarIconType } from "./types";

export const sidebarIcons: Record<SidebarIconType, LucideIcon> = {
  home: GlobeIcon,
  overview: Info,
  guardrails: Shield,
  outcomes: Target,
  history: Clock,
  chat: MessageSquare,
  benchmark: FlaskConical,
  situation: NotebookPen,
  segments: Layers3,
  suggestion: Lightbulb,
  actions: ListChecks,
  doc: FileText,
  details: ScrollText,
};
